import {
  IAuthModalInput,
  IAuthModalInputMask,
} from "shared/components/organisms/AuthModal/types";

import {
  AuthModalInputContainer,
  AuthModalInputMaskContainer,
} from "../styles";

const AuthModalInputBase = ({
  label,
  isInputRequired,
  Icon = null,
  children,
}) => {
  return (
    <AuthModalInputContainer isInputRequired={isInputRequired}>
      <label htmlFor={label}>{label}</label>
      {children}
      {Icon ? <Icon /> : null}
    </AuthModalInputContainer>
  );
};

export const AuthModalInput = ({
  type,
  label,
  Icon,
  required,
  ...props
}: IAuthModalInput) => {
  return (
    <AuthModalInputBase label={label} Icon={Icon} isInputRequired={required}>
      <input
        required={required}
        id={label}
        type={type}
        {...props}
        autoComplete="off"
      />
    </AuthModalInputBase>
  );
};

export const AuthModalInputWithMask = ({
  label,
  required,
  ...props
}: IAuthModalInputMask) => {
  return (
    <AuthModalInputBase isInputRequired={required} label={label}>
      <AuthModalInputMaskContainer required={required} {...props} />
    </AuthModalInputBase>
  );
};
